<template>
  <div>
    <div class="WachtOpClient">
      <div class="token">
        <img src="/images/left-arrow.png" />
      </div>
      <div class="instructie">Start: leg het pasje naast het scherm.</div>
    </div>
    <div class="debuginfo" v-show="lastlog">Info: {{ lastlog }}</div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "wachtopclient",
  components: {},
  data() {
    return {
      ConsoleNaam: "Prototype-001",
      checkresult: "",
      lastlog: "Er staat geen vragenset klaar voor dit token.",
    };
  },
  methods: {
    registreerConsole: function () {
      this.$api.pRegisterConsole({ ConsoleNaam: this.ConsoleNaam });
    },
    checkToken: function () {
      this.$api.pTokenCheck({ ConsoleNaam: this.ConsoleNaam }).then((response) => {
        let res = response.data[0];
        if (res.Result == "Ok") {
          this.lastlog = res.LastLog;
          window.location = "/vragenlijst/" + res.VragenSessieId.toString();
        } else {
          this.lastlog = res.LastLog;
        }
      });
    },
  },
  created: function () {
    this.registreerConsole();
    setInterval(this.checkToken, 3000);
  },
};
</script>

<style scoped>
/* Algemene css, voorheen uit app.vue. Nu alleen voor Vinnie-schermen, de rest is nu Vuetify */
#app {
  font-family: "Trebuchet MS", Arial, sans-serif;
  font-weight: 300;
  color: #2c3e50;
  margin-top: 0px;
}

html {
  overflow-y: scroll;
}

body {
  margin: 0px;
}

.content-div {
  min-height: 500px;
  width: 1260px;
  margin-left: auto;
  margin-right: auto;
}

/* Einde algemene css */

.token {
  width: 315px;
  height: 500px;
  border: 3px solid white;
  border-radius: 20px;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.WachtOpClient {
  display: flex;
  margin-top: 130px;
  height: 500px;
}

.instructie {
  margin-left: 50px;
  font-size: 36pt;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.debuginfo {
  margin-top: 80px;
  color: gray;
  font-size: 12px;
  text-align: right;
}
</style>
